<template>
  <div class="pcb-cart" :style="{ width: width, backgroundColor: bg }">
    <div class="t" data-eusoft-scrollable-element="1">
      <div class="pcb-cart-boxQuoteRightInfo">PCB Price：</div>

      <div class="bnGetQPM" v-if="stauts.list.length > 0">
        <slot name="header_right"></slot>
      </div>
    </div>
    <!-- pcb table -->
    <div class="pcb-table">
      <div class="pcb-table__header">
        <div class="pcb-table__cell" style=""></div>
        <div class="pcb-table__cell">Build Time</div>
        <div class="pcb-table__cell">Qty</div>
        <div class="pcb-table__cell">Total</div>
      </div>
      <div
        v-for="(item, index) in stauts.list"
        style="padding: 0.5em 0.3em;margin-top: 10px;"
        :class="{ 'pcb-table__row--selected': stauts.selected === index }"
      >
        <div class="pcb-table__row">
          <div class="pcb-table__cell">
            <div
              class="pcb-table__radio-wrapper"
              @click="handleSelect(item, index)"
            >
              <div
                class="pcb-table__radio-custom"
                :class="{
                  'pcb-table__radio-custom--selected':
                    stauts.selected === index,
                }"
              >
                <div
                  class="pcb-table__radio-check"
                  v-if="stauts.selected === index"
                >
                  ✓
                </div>
              </div>
            </div>
            <input
              type="radio"
              name="material"
              :checked="stauts.selected === index"
              class="pcb-table__radio-hidden"
              style="display: none"
            />
          </div>
          <div class="pcb-table__cell">{{ item?.DeliveryDays }} D</div>
          <div class="pcb-table__cell">{{ item?.PcbOrder?.PcsNum || "-" }}</div>
          <div class="pcb-table__cell">
            ${{ item.TotalMoney || "-" }}
          </div>
        </div>
      </div>
    </div>
    <hr style="margin: 10px 0; border: 1px solid #f0f0f0" />
    <!-- pcba table -->
    <div class="t" data-eusoft-scrollable-element="1" v-if="showPcba">
      <div class="pcb-cart-boxQuoteRightInfo">Assembly Service Price:</div>
    </div>
    <div class="pcb-table" v-if="showPcba">
      <div class="pcb-table__header">
        <div class="pcb-table__cell" style=""></div>
        <div class="pcb-table__cell">Qty</div>
        <div class="pcb-table__cell">Unit Price</div>
        <div class="pcb-table__cell">Total</div>
      </div>
      <div
        v-for="(item, index) in stauts.list"
        style="padding: 0.5em 0.3em"
        :class="{ 'pcb-table__row--selected': stauts.selected === index }"
      >
        <div class="pcb-table__row">
          <div class="pcb-table__cell">
            <div
              class="pcb-table__radio-wrapper"
              @click="handleSelect(item, index)"
            >
              <div
                class="pcb-table__radio-custom"
                :class="{
                  'pcb-table__radio-custom--selected':
                    stauts.selected === index,
                }"
              >
                <div
                  class="pcb-table__radio-check"
                  v-if="stauts.selected === index"
                >
                  ✓
                </div>
              </div>
            </div>
            <input
              type="radio"
              name="material"
              :checked="stauts.selected === index"
              class="pcb-table__radio-hidden"
              style="display: none"
            />
          </div>
          <div class="pcb-table__cell">{{ item?.DeliveryDays }} hours</div>
          <div class="pcb-table__cell">{{ item?.TotalMoney || "-" }}/pc</div>
          <div class="pcb-table__cell">
            ${{ item.TotalMoney || "-" }}
          </div>
        </div>
      </div>
    </div>
    <hr v-if="showPcba" style="margin: 10px 0; border-color: #f0f0f0" />
    <div v-if="stauts.list.length > 0">
      <!-- <div class="noteFPIS">Final price is subject to our review.</div> -->
      <!-- price info -->
      <div class="priceInfo" style="display: block">
        <div class="calculatedPrice">
          <span class="cp">Calculated Price:</span>
          <span>
            <span class="disPrice">
              <span class="pcb-cart-orgPrice"
                v-show="stauts.realPrice > 0"
                >${{ stauts.realPrice.toFixed(2) }}</span
              >
              ${{ stauts.price.toFixed(2) }}</span
            >
          </span>
        </div>
        <div class="tag" style="display: none">
          <span class="tle"></span>
        </div>
        <div class="distag" style="display: none">
          <span class="title">SAVE <span class="value"></span></span>
        </div>
        <!-- <div
          class="noticeCDVAT"
          style="color: #ff4b4e; font-weight: 700; font-size: 12px"
        >
          <div class="pcb-cart-tag" style="display: block">
            <span class="tle"
              >This offer is valid only for new users making their first
              order.<br />Duplicate accounts are not eligible for the $30
              discount.</span
            >
          </div>
          <span>Notice: Customs duties and VAT are not included.</span>
        </div> -->
      </div>
      <div class="pcb-cart-button">
        <button @click="handleQuoteDetails" class="pcb-cart-btn pcb-cart-btn--quote">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="pcb-cart-btn-icon"
            width="16"
            height="16"
            viewBox="0 0 15 18"
            fill="none"
          >
            <g clip-path="url(#clip0_973_896)">
              <path
                d="M11.0889 18H2.92256C2.03969 18 1.32422 17.248 1.32422 16.3198V5.03563C1.32422 4.10749 2.03969 3.35547 2.92219 3.35547H11.0885C11.9714 3.35547 12.6869 4.10749 12.6869 5.03563V16.3198C12.6869 17.248 11.9714 18 11.0889 18ZM2.92256 4.47558C2.85237 4.47573 2.78289 4.49035 2.71811 4.51859C2.65332 4.54683 2.5945 4.58814 2.545 4.64015C2.49551 4.69217 2.45631 4.75387 2.42965 4.82173C2.403 4.88959 2.38941 4.96228 2.38966 5.03563V16.3198C2.38966 16.4687 2.44609 16.6107 2.5457 16.7156C2.64569 16.8209 2.78129 16.8799 2.92256 16.8799H11.0885C11.1587 16.8797 11.2282 16.8651 11.293 16.8369C11.3578 16.8086 11.4166 16.7673 11.4661 16.7153C11.5156 16.6633 11.5548 16.6016 11.5814 16.5337C11.6081 16.4659 11.6217 16.3932 11.6214 16.3198V5.03563C11.6217 4.96228 11.6081 4.88959 11.5814 4.82173C11.5548 4.75387 11.5156 4.69217 11.4661 4.64015C11.4166 4.58814 11.3578 4.54683 11.293 4.51859C11.2282 4.49035 11.1587 4.47573 11.0885 4.47558H2.92256Z"
                fill="#0060FF"
              ></path>
              <path
                d="M12.1502 8.10536H1.86091C1.56435 8.10536 1.32422 7.83939 1.32422 7.51167C1.32422 7.18395 1.56435 6.91797 1.86091 6.91797H12.1502C12.4467 6.91797 12.6869 7.18395 12.6869 7.51167C12.6869 7.83939 12.4467 8.10536 12.1502 8.10536ZM3.59675 10.4802C3.59675 10.6901 3.67656 10.8914 3.81862 11.0399C3.96068 11.1883 4.15335 11.2717 4.35426 11.2717C4.55516 11.2717 4.74784 11.1883 4.8899 11.0399C5.03196 10.8914 5.11177 10.6901 5.11177 10.4802C5.11177 10.2702 5.03196 10.0689 4.8899 9.92041C4.74784 9.77196 4.55516 9.68856 4.35426 9.68856C4.15335 9.68856 3.96068 9.77196 3.81862 9.92041C3.67656 10.0689 3.59675 10.2702 3.59675 10.4802ZM6.62679 10.4802C6.62679 10.6901 6.7066 10.8914 6.84866 11.0399C6.99072 11.1883 7.18339 11.2717 7.3843 11.2717C7.5852 11.2717 7.77788 11.1883 7.91994 11.0399C8.062 10.8914 8.14181 10.6901 8.14181 10.4802C8.14181 10.2702 8.062 10.0689 7.91994 9.92041C7.77788 9.77196 7.5852 9.68856 7.3843 9.68856C7.18339 9.68856 6.99072 9.77196 6.84866 9.92041C6.7066 10.0689 6.62679 10.2702 6.62679 10.4802ZM9.27807 10.4802C9.27807 10.6901 9.35788 10.8914 9.49994 11.0399C9.642 11.1883 9.83468 11.2717 10.0356 11.2717C10.2365 11.2717 10.4292 11.1883 10.5712 11.0399C10.7133 10.8914 10.7931 10.6901 10.7931 10.4802C10.7931 10.2702 10.7133 10.0689 10.5712 9.92041C10.4292 9.77196 10.2365 9.68856 10.0356 9.68856C9.83468 9.68856 9.642 9.77196 9.49994 9.92041C9.35788 10.0689 9.27807 10.2702 9.27807 10.4802ZM3.59675 14.0423C3.59675 14.2523 3.67656 14.4536 3.81862 14.6021C3.96068 14.7505 4.15335 14.8339 4.35426 14.8339C4.55516 14.8339 4.74784 14.7505 4.8899 14.6021C5.03196 14.4536 5.11177 14.2523 5.11177 14.0423C5.11177 13.8324 5.03196 13.631 4.8899 13.4826C4.74784 13.3341 4.55516 13.2507 4.35426 13.2507C4.15335 13.2507 3.96068 13.3341 3.81862 13.4826C3.67656 13.631 3.59675 13.8324 3.59675 14.0423ZM6.62679 14.0423C6.62679 14.2523 6.7066 14.4536 6.84866 14.6021C6.99072 14.7505 7.18339 14.8339 7.3843 14.8339C7.5852 14.8339 7.77788 14.7505 7.91994 14.6021C8.062 14.4536 8.14181 14.2523 8.14181 14.0423C8.14181 13.8324 8.062 13.631 7.91994 13.4826C7.77788 13.3341 7.5852 13.2507 7.3843 13.2507C7.18339 13.2507 6.99072 13.3341 6.84866 13.4826C6.7066 13.631 6.62679 13.8324 6.62679 14.0423ZM9.27807 14.0423C9.27807 14.2523 9.35788 14.4536 9.49994 14.6021C9.642 14.7505 9.83468 14.8339 10.0356 14.8339C10.2365 14.8339 10.4292 14.7505 10.5712 14.6021C10.7133 14.4536 10.7931 14.2523 10.7931 14.0423C10.7931 13.8324 10.7133 13.631 10.5712 13.4826C10.4292 13.3341 10.2365 13.2507 10.0356 13.2507C9.83468 13.2507 9.642 13.3341 9.49994 13.4826C9.35788 13.631 9.27807 13.8324 9.27807 14.0423Z"
                fill="#0060FF"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_973_896">
                <rect width="14.0139" height="18" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
          Quote Details
        </button>
        <button @click="handleAddToCart" class="pcb-cart-btn pcb-cart-btn--cart">Add to Cart</button>
      </div>
    </div>
  </div>
  <div class="pcb-cart-parcel">
    <pcbParcel :width="width" ref="pcbParcelRef" :stauts="stauts" :countrys="stauts.countrys" :CalShip="props.CalShip"></pcbParcel>
  </div>
</template>

<script setup>
import pcbButton from "../button.vue";
import { reactive, onMounted, ref,unref,nextTick } from "vue";
import pcbParcel from "./parcel.vue";
defineOptions({
  name: "pcb-cart",
});
const props = defineProps({
  width: {
    type: String,
    default: () => "100%",
  },
  bg: {
    type: String,
    default: () => "#fff",
  },
  showPcba:{
    type: Boolean,
    default: false,
  },
  CalShip:{
    type:Function,
    default:()=>{
      return []
    }
  }
});
const pcbParcelRef=ref(null);
const stauts = reactive({
  list: [],
  selected: 0,
  price: 0,
  realPrice: 0,
  countrys: [],
});
onMounted(() => {
});
const emits = defineEmits(["detail","addCart"]);
function init(list) {
    stauts.list = list;
    handleSelect(stauts.list[0], 0);
}
function set(list=[]) {
  stauts.list = list;
  if(list.length>0){
  handleSelect(stauts.list[0], 0);
  nextTick(()=>{
    pcbParcelRef.value.init();
  })
  }
}
function getFIleName(url) {
  //  "Captions_": "/img/img/onlineNew/pdf/KingboardKB-6165F.pdf",
  return url.split("/").pop().split(".")[0];
}
function handleSelect(item, index) {
  stauts.selected = index;
  stauts.price = item?.TotalMoney ?? 0;
}
function handleQuoteDetails() {
  emits("detail");
}
function handleAddToCart() {
  emits("addCart");
}
function setCountrys(countrys) {
  if(countrys.length > 0) {
    countrys.value = countrys;
  } else {
    countrys.value = [];
  }
}
function setColumn(key,columns) {
  // 使用 Reflect.set 确保响应式
  Reflect.set(stauts, key, columns);
}
function get(){
  return unref(stauts.list[stauts.selected])
}
function initCart(){
  nextTick(()=>{
    pcbParcelRef.value.init();
  })
}
defineExpose({
  set,
  setColumn,
  get,
  init,
  initCart
})
</script>

<style scoped>
.pcb-cart {
  width: 100%;
  padding: 10px 20px 25px 20px;
  border-radius: 5px;
  box-sizing: border-box;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
}
.priceInfo {
  margin-bottom: 14px;
  display: none;
}
.priceInfo .tag {
  display: none;
}
.calculatedPrice {
  height: 42px;
  margin-top: 14px;
  border-radius: 0px 0px 0px 0px;
  line-height: 42px;
}

.calculatedPrice .cp {
  float: left;
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  /*line-height: 23px;*/
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.calculatedPrice .orgPrice,
.disPrice {
  float: right;
  font-style: normal;
  text-transform: none;
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: bold;
  line-height: 42px;
}

.calculatedPrice .orgPrice {
  position: relative;
  top: 5px;
  font-size: 16px;
  color: #bfbfbf;
  margin-right: 8px;
  text-decoration-line: line-through;
}

.calculatedPrice .disPrice {
  font-size: 16px;
  font-weight: bold;
  color: var(--primary-color, #0060ff);
font-family: 'HarmonyOS_Sans';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 42px;
/* or 143% */
display: flex;
align-items: center;
text-align: right;



}

.noteFPIS {
  padding: 1em 0;
  border-bottom: 2px solid #eee;
  position: relative;
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: 400;
  font-size: 12px;
  color: #8c8c8c;
  line-height: 12px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.cart .t {
  margin: 20px 0.7em 15px 0.7em;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cart .bnGetQPM:hover {
  border: 1px solid var(--main-color);
  color: var(--main-color);
}
.pcb-table {
  width: 100%;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.pcb-table__header,
.pcb-table__row {
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr 3fr 3fr 2fr;
  align-items: stretch; /* 拉伸对齐，让每个单元格填满行高 */
}
.pcb-table__header {
  height: 22px;
  line-height: 22px;
  background-color: #eff5ff !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 5px 0;
  font-family: "HarmonyOS_Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #787b80 !important;
}

/* 表头单元格也应用居中样式 */
.pcb-table__header .pcb-table__cell {
  justify-content: flex-start;
  align-items: center; /* 确保表头也垂直居中 */
  font-family: 'HarmonyOS_Sans';
font-style: normal;
font-weight: 400;
font-size: 13px;
line-height: 23px;
/* or 176% */
display: flex;
align-items: center;
color: rgba(0, 0, 0, 0.5);
}
.pcb-table__header {
  /* font-weight: bold; */
  background: #fafafa;
}

.pcb-table__row:hover {
  background: #f9f9f9;
}

.pcb-table__row--selected {
  /* background: #e3f3ff; */
  /* border-left: 3px solid #1890ff; */
}

.pcb-table__cell {
  position: relative;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: flex-start; /* 水平居中 */
  gap: 6px;
  text-align: start; /* 作为备用，对文本节点生效 */
  padding: 0px .2em; /* 增加垂直内边距，确保有足够空间居中 */
  font-family: "HarmonyOS_Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #333333;
}

/* 包含链接的单元格特殊处理 */
.pcb-table__cell--link {
  padding-left: 8px;
  gap: 4px; /* 减小间距 */
  justify-content: flex-start;
  align-items: flex-start; /* 顶部对齐，适应多行内容 */
}

/* 链接文本容器 */
.pcb-table__link-wrapper {
  flex: 1;
  min-width: 0; /* 允许文本收缩 */
  position: relative;
  overflow: hidden; /* 防止内容溢出 */
  word-wrap: break-word; /* 容器级别的换行控制 */
}

/* 自定义单选按钮样式 */
.pcb-table__radio-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pcb-table__radio-custom {
  width: 13px;
  height: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
}

.pcb-table__radio-custom--selected {
  border-color: var(--main-color);
  background-color: var(--main-color);
}

.pcb-table__radio-check {
  transform: rotateX(45deg);
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  line-height: 2em;
}

.pcb-table__radio-wrapper:hover .pcb-table__radio-custom {
  border-color: var(--main-color);
}

.pcb-table__radio {
  margin: 0;
}

/* 原有的图标样式已移除，现在使用伪元素 */

.pcb-table__price {
  font-weight: bold;
  color: #f90;
}
.pcb-table__link {
  padding: 0 22px 0 26px; /* 左右预留图标空间 */
  font-size: 12px;
  text-decoration: underline;
  color: #333;
  text-align: left;
  width: 100%;
  max-width: 100%; /* 确保不超出容器 */
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词换行 */
  overflow-wrap: break-word; /* 现代浏览器换行属性 */
  word-break: break-all; /* 强制断行，包括英文单词 */
  line-height: 1.4; /* 增加行高，让多行文本更清晰 */
  display: inline-block; /* 改为 inline-block，更好地处理换行 */
  position: relative;
  box-sizing: border-box; /* 包含 padding 在宽度计算内 */
}

/* PDF 图标 - before 伪元素 */
.pcb-table__link::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background-image: url("https://www.Aivon.com/img/img/onlineNew/pdf_new.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
}

/* 下载图标 - after 伪元素 */
/* .pcb-table__link::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background-image: url("https://www.Aivon.com/img/img/onlineNew/ul.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
} */
.pcb-table__link:hover {
  color: #f90;
}

.pcb-cart-tag {
  text-align: right;
  width: 100%;
  min-height: 20px;
  margin-bottom: 4px;
  /* Rectangle 34624814 */

  box-sizing: border-box;

  background: #ecfbfc;
  border: 1px solid #cff1f0;
  border-radius: 3px;
  font-family: "HarmonyOS_Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  /* or 142% */
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 0px;
  text-align: right;
  color: #8c8c8c;
}
.pcb-cart-orgPrice {
  position: relative;
  top: 0px;
  font-size: 16px;
  color: #bfbfbf;
  margin-right: 8px;
  text-decoration-line: line-through;
}
.pcb-cart-boxQuoteRightInfo {
  font-size: 16px;
  font-weight: bold;
  margin: 1em 0 0.7em;
}
.pcb-cart-parcel {
  margin-top: 12px;
}

/* 按钮容器样式 */
.pcb-cart-button {
  display: flex;
  gap: 0px;
  margin-top: 16px;
}

/* 按钮基础样式 */
.pcb-cart-btn {
  height: 44px;
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: 500;
  font-size: 14px;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 20px;
}

/* Quote Details 按钮样式 */
.pcb-cart-btn--quote {
  flex: 15;
  background: #ffffff;
  border: 1px solid #0060ff;
  color: #0060ff;
  border-radius: 4px 0 0 4px;
}

.pcb-cart-btn--quote:active {
  background: #cce0ff;
}

/* Add to Cart 按钮样式 */
.pcb-cart-btn--cart {
  flex: 22;
  background: #0060ff;
  color: #ffffff;
  border-radius: 0 4px 4px 0;
}
  .pcb-cart-btn--cart:hover {
    background: var(--primary-color__hover);
  }
  .pcb-cart-btn--cart:active {
    background: var(--primary-color__active);
  }

/* 按钮图标样式 */
.pcb-cart-btn-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
</style>
